import { createClasses } from "@bloomberg/media-ui-core";
import React from "react";
import { PropsWithClassAndChildren } from "../types";

import styles from "./GridLeftContent.module.css";

export function GridLeftContent({
  children,
  className,
  ...args
}: PropsWithClassAndChildren) {
  const cx = createClasses([styles.gridLeftContent, className]);

  return (
    <aside className={cx} {...args}>
      {children}
    </aside>
  );
}
